import React from 'react';
import PropTypes from 'prop-types';
import { faUsdCircle } from '@fortawesome/pro-solid-svg-icons/faUsdCircle';

import BulkAction from './BulkAction';

const AddCredit = ({
  showModal,
  ...rest
}) => (
  <BulkAction
    icon={faUsdCircle}
    title='Add Credit'
    onClick={() => showModal('BulkAddTransaction', {
      type: 'credit',
      ...rest
    })}
    {...rest}
  />
);

AddCredit.propTypes = {
  /** The contacts we wish to add a credit to */
  contacts: PropTypes.arrayOf(
    PropTypes.string
  ),

  /** Allows us to show a modal */
  showModal: PropTypes.func
};

AddCredit.defaultProps = {
  contacts: [],
  showModal: () => false
};

export default AddCredit;
